import type { IAdminMembershipRepository } from "@/application/ports/repositories";
import type {
  MembershipCreateRequest,
  MembershipUpdateRequest,
  AdminMembership,
} from "@/domain/admin";
import { deadEndpoint } from "../deadEndpoint";
import type { OrganizationRole } from "../generated/types.gen";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class AdminMembershipRepository implements IAdminMembershipRepository {
  async createMembership(_data: MembershipCreateRequest): Promise<AdminMembership> {
    // Dead endpoint: POST /admin/memberships never existed in the backend.
    return deadEndpoint("POST", "/admin/memberships");
  }
  async updateMembership(uuid: string, data: MembershipUpdateRequest): Promise<AdminMembership> {
    // UI still offers legacy role values; the backend enum validates (422 on invalid)
    return unwrap(
      sdk.adminUpdateMembership({
        path: { membership_uuid: uuid },
        body: { ...data, role: data.role as OrganizationRole | undefined },
      }),
    );
  }
  async deleteMembership(uuid: string): Promise<void> {
    await unwrap(sdk.adminDeleteMembership({ path: { membership_uuid: uuid } }));
  }
  async getUserMemberships(userUuid: string): Promise<AdminMembership[]> {
    return unwrap(sdk.getUserMemberships({ path: { user_uuid: userUuid } }));
  }
}
